const ded = `<p><strong>Terms of Service</strong>
<strong>DressDown.me</strong><strong>
Effective Date: 01.05.25</strong></p>
<p><strong>Introduction</strong>
These Terms of Service (“Agreement”) govern access to and use of the Services offered by DressDown.me, including AI-powered image editing, transformation, and generation technologies, including artificial intelligence algorithms (“Services”).
By using the Services, you agree to comply with this Agreement and all applicable laws. If you disagree with any terms, please discontinue use of the Services.</p>
<ul>
  <li><strong>Services</strong></li>
</ul>
<p><strong>1.1 Purpose and Use of the Services</strong>
We provide users with access to Services that allow:
• Uploading photos;
• Making visual modifications to images;
• Generating new visual materials using AI technologies (including but not limited to StyleGAN and other algorithms).
Use of the Services is permitted solely for personal and non-commercial purposes, in accordance with these Terms.</p>
<ul>
  <li><strong>1.2 Account Registration</strong></li>
</ul>
<p>To access certain features of the Services, you must register an account. You agree to:
• Provide accurate and complete information;
• Maintain the security of your password and account;
• Notify us immediately of any unauthorized use of your account.</p>
<ul>
  <li><strong>2. Intellectual Property Rights</strong></li>
</ul>
<p><strong>2.1 Ownership</strong>
All content, software, text, images, videos, and other materials provided through the Services are either owned by DressDown.me or licensed to us. You may not use, reproduce, distribute, or create derivative works without our express written permission.</p>
<ul>
  <li><strong>2.2 User Content License</strong></li>
</ul>
<p>By uploading content, you grant us a worldwide, royalty-free, non-exclusive license to use, reproduce, modify, and display your content solely to provide and improve the Services.</p>
<ul>
  <li><strong>3. Prohibited Conduct</strong></li>
</ul>
<p>You agree not to:
• Reverse engineer, decompile, or disassemble any aspect of the Services;
• Use the Services for any unlawful, harmful, or prohibited purpose;
• Upload or transmit any material that infringes rights of others or violates applicable laws;</p>
<ul>
  <li><strong>4. Fees and Payment</strong></li>
</ul>
<p>If applicable, you agree to pay all fees in accordance with our pricing and payment terms. All payments are non-refundable except as required by law.</p>
<ul>
  <li><strong>5. Disclaimer of Warranties</strong></li>
</ul>
<p>The Services are provided “as is” and “as available” without warranties of any kind. We disclaim all warranties, whether express, implied, statutory, or otherwise.</p>
<ul>
  <li><strong>6. Limitation of Liability</strong></li>
</ul>
<p>To the maximum extent permitted by law, DressDown.me will not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with the Services.</p>
<ul>
  <li><strong>7. Indemnification</strong></li>
</ul>
<p>You agree to indemnify and hold harmless DressDown.me and its affiliates from any claims arising from your breach of this Agreement or your use of the Services.</p>
<ul>
  <li><strong>8. Termination</strong></li>
</ul>
<p>We may suspend or terminate your access to the Services at any time for any reason, without notice. Upon termination, all licenses and rights granted to you will immediately cease.</p>
<ul>
  <li><strong>9. Governing Law</strong></li>
</ul>
<p>This Agreement is governed by the laws of the European Union and the Republic of Poland, without regard to its conflict of laws principles.</p>
<ul>
  <li><strong>10. Changes to the Terms</strong></li>
</ul>
<p>We may update these Terms from time to time. Changes become effective upon posting. Your continued use after changes constitutes acceptance.</p>
<ul>
  <li><strong>11. Contact Us</strong></li>
</ul>
<p>If you have any questions about these Terms, please contact us at <a href="mailto:support@dressdown.me">support@dressdown.me</a>.</p>`;

export default ded
